import { DateTime } from 'luxon';

export const DATE_DISPLAY_FORMAT = 'dd-MMM-yyyy';
export const DATE_WITH_TIME_DISPLAY_FORMAT = `${DATE_DISPLAY_FORMAT} hh:mm a`;
export const DISPENSE_INTERVAL_FALLBACK_TZ = 'Australia/Melbourne';

export const numberFormat = (
  value: number,
  locale = 'en-AU',
  options: Partial<Intl.NumberFormatOptions> = {
    style: 'currency',
    currency: 'AUD',
  },
) => new Intl.NumberFormat(locale, options).format(value);

/**
 * Formats an ISO date for display on the front end
 * @param isoDate A date formatted with .toISOString()
 * @returns A date formatted dd-MMM-yyyy (ex. 19-Oct-2025)
 */
export const formatISODateHelper = (isoDate: string | undefined) => {
  return isoDate && DateTime.fromISO(isoDate).toFormat(DATE_DISPLAY_FORMAT);
};

export default {
  numberFormat,
};
